import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsg26rabxb: FaireProductEntity = {
  token: "p_tsg26rabxb",
  type: "product",
  name: "IWON ORGANICS PROTEIN STIX 8/1.5OZ SWEET DIJON",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/51daefc5033a32c912b29077f7a451b69d9e1f8353706eb7dcc45543261ac84e.jpeg",
  galleryImageUrls: [],
  priceDollars: 31.8,
  description:
    "These Protein Stix offer a sweet and tangy Dijon mustard flavor, providing a unique and satisfying taste experience. Each serving is high in protein and fiber, supporting a balanced diet. The stix are made with plant-based proteins and are certified USDA Organic, Non-GMO, gluten-free, soy-free, kosher, and vegan, accommodating various dietary needs. They are perfectly baked to provide a satisfying crunch and bold flavor, making them an excellent choice for a wholesome snack.",
  tags: [],
  msrpDollars: 47.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:12.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
